module.exports = __webpack_public_path__ + "plat/static/img/end.273bc30c.svg";